/**
 * LOCOBOOK Module
 */
//Core
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BtnModule } from '../ui_button/btn.module';

import { BtnComponent } from '../ui_button/btn.component';
import { SearchFormComponent } from "../ui_forms/searchForm/searchForm.component";
import { BasicFormComponent } from "../ui_forms/basicForm/basicForm.component";
import { DropdownComponent } from "../ui_dropdown/dropdown.component";
import { MessageComponent } from "../ui_message/message.component";
import { CardModule } from '../ui_card/card.module';

import { ClickOutsideDirective } from "../ui_clickOutside/clickOutside.directive";
import { ClickOutsideModule } from "../ui_clickOutside/clickOutside.module";
import { CreateFormModule } from "../ui_forms/createForm/createForm.module";
import { DropdownModule } from "../ui_dropdown/dropdown.module";
import { ModalModule } from "../ui_modal/Modal.module";
import { FocusIfModule } from 'libraries/ui_toolbox/focus-if.module';
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        BtnModule,
        CardModule,
        ClickOutsideModule,
        CreateFormModule,
        DropdownModule,
        ModalModule,
        FocusIfModule,
        FontAwesomeModule,
    ],
    declarations: [
        SearchFormComponent,
        MessageComponent,
        BasicFormComponent,
    ],
    providers: [],
    exports: [
        SearchFormComponent,
        DropdownComponent,
        MessageComponent,
        ClickOutsideDirective,
        BasicFormComponent,
        BtnComponent,
    ]


})
export class UIModule {
}
